import { render, staticRenderFns } from "./clienteAgrupado.vue?vue&type=template&id=11d5dc28"
import script from "./clienteAgrupado.vue?vue&type=script&lang=js"
export * from "./clienteAgrupado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports